import React from 'react';
import { ScrollView } from 'react-native';
import { useQuery } from '@apollo/client';

import DataState from 'app/src/components/DataState';
import AssetCard from 'app/src/elements/AssetCard';
import { CardContainer, PageTitle } from 'app/src/elements';

import { UPCOMING_SALE_ASSETS } from './queries';

const UpcomingAssets = () => {
  const { loading, data } = useQuery(UPCOMING_SALE_ASSETS);

  if (loading || !data?.upcomingSaleAssets) { return <DataState.Loading />; }

  return (
    <>
      <PageTitle>Assets in Upcoming Sales</PageTitle>
      <ScrollView>
        <CardContainer>
          {data?.upcomingSaleAssets?.map(saleAsset => (
            <AssetCard
              saleAsset={saleAsset}
              key={saleAsset.id}
            />
          ))}
        </CardContainer>
      </ScrollView>
    </>
  );
};

export default UpcomingAssets;
